import { render, staticRenderFns } from "./all-brand.vue?vue&type=template&id=bbc3a640&scoped=true&"
import script from "./all-brand.vue?vue&type=script&lang=js&"
export * from "./all-brand.vue?vue&type=script&lang=js&"
import style0 from "./all-brand.vue?vue&type=style&index=0&id=bbc3a640&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc3a640",
  null
  
)

export default component.exports